// extracted by mini-css-extract-plugin
module.exports = {"tagContainer":"Tags_tagContainer__WvpEt"};